<template>
  <div>Dashboard works!</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
